import { Slider, StatefulSliderProps } from 'baseui/slider';
import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';

export default function StatefulSlider({ name, ...props }: { name: string } & Exclude<StatefulSliderProps, 'onChange'>) {
    const [n, setN] = useState<number>(props.initialState?.value?.[0] || props.min || 0);

    return (<>
        <input type="hidden" name={name} value={n} />
        <Slider {...props} onChange={({value}) => setN(value[0])} value={[n]} />
    </>);
}
